var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import messages from '@/modules/tasks/taskMessages';
import { useGetAssignmentTemplates } from '@/shared/hooks/task/useGetAssignmentTemplates';
import guid from '@/shared/utils/guid';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import { hasAssignments } from '../../security/HasAssignments';
import AutoComplete from '../select/AutoComplete';
export var AssignmentTemplateSelector = function (_a) {
    var initialValue = _a.initialValue, placeholder = _a.placeholder, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var data = useGetAssignmentTemplates().data;
    var assignmentTemplates = useMemo(function () {
        return data === null || data === void 0 ? void 0 : data.map(function (item) { return ({
            key: item.id,
            label: formatMessage(listItemMsg('assignmenttemplate', item.id, item.name)),
        }); });
    }, [data, formatMessage]);
    var items = useMemo(function () {
        var _a;
        return (_a = (assignmentTemplates && __spreadArray([
            { key: guid.empty, label: formatMessage(messages.DefaultAssignment) }
        ], assignmentTemplates, true))) !== null && _a !== void 0 ? _a : undefined;
    }, [assignmentTemplates, formatMessage]);
    var initialSelectedItem = useMemo(function () { var _a; return (_a = (initialValue && (items === null || items === void 0 ? void 0 : items.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === initialValue; })))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, items]);
    return (_jsx(AutoComplete, { items: items, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: function (item) { return onChange(item === null || item === void 0 ? void 0 : item.key); } }));
};
export var FilterAssignmentTemplateSelector = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: hasAssignments() ? (_jsx(AssignmentTemplateSelector, { initialValue: activeFilters[item], onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, placeholder: label })) : null,
    });
};
